export enum PolygonType {
  annotation = 'annotation',
  LABEL = 'LABEL',
  MultiPolygon = 'MultiPolygon'
}
